import React, { useState, useEffect } from 'react';
import { 
  getActivityIcon,
  getActivityColor,
  getActivityDescription,
  processTaskActivityHistory,
  formatDate
} from '../utils/activityHelpers';

// Componente para mostrar la línea de tiempo de actividades de una tarea
function ActivityTimeline({ task, isVisible }) {
  const [activities, setActivities] = useState([]);
  const [expanded, setExpanded] = useState(false);

  // La función formatUserName ahora se importa desde activityHelpers

  // Las funciones de parsing de timestamps ahora se importan desde activityHelpers

  // La función formatDate ahora se importa desde activityHelpers

  // La función getActivityIcon ahora se importa desde activityHelpers

  // La función getActivityColor ahora se importa desde activityHelpers

  // La función getActivityDescription ahora se importa desde activityHelpers

  // Procesar el historial de la tarea para generar la línea de tiempo
  useEffect(() => {
    if (task && isVisible) {
      const processedActivities = processTaskActivityHistory(task);
      setActivities(processedActivities);
    }
  }, [task, isVisible]);

  // Si no hay actividades, mostrar mensaje
  if (activities.length === 0) {
    return (
      <div className="activity-timeline-empty">
        <p>No hay actividades registradas para esta tarea.</p>
      </div>
    );
  }

  return (
    <div className="activity-timeline">
      <div className="activity-timeline-header" onClick={() => setExpanded(!expanded)}>
        <span className="activity-icon">📋</span>
        <h4>Historial de actividad</h4>
        <span className="toggle-icon">{expanded ? '▼' : '►'}</span>
      </div>
      
      {expanded && (
        <div className="activity-timeline-content">
          {activities.map((activity) => (
            <div 
              key={activity.id} 
              className="activity-item"
              style={{ backgroundColor: getActivityColor(activity.type) }}
            >
              <div className="activity-icon-container">
                <span className="activity-type-icon">{getActivityIcon(activity.type)}</span>
              </div>
              <div className="activity-details">
                <div className="activity-description">
                  {getActivityDescription(activity.type, activity)}
                </div>
                <div className="activity-timestamp">
                  <span className="activity-date">{formatDate(activity.timestamp)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ActivityTimeline; 